// extracted by mini-css-extract-plugin
module.exports = {"icon-addon":"_2bGcAOzko0wLPSHBobrjE6"};